import {
  ChartBarIcon,
  HomeIcon,
  RssIcon,
  TrashIcon,
  AcademicCapIcon,
  PencilIcon,
  ArrowPathIcon,
  WalletIcon,
  ChartPieIcon,
  ShareIcon,
  WindowIcon,
  BuildingLibraryIcon,
  FolderIcon,
} from '@heroicons/react/24/outline'
import { NavLink, useLocation } from 'react-router-dom'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

function Sidebar3(){

  const location = useLocation()

  const navigation = [
      { name: 'Validador', href: '/valPage', icon: HomeIcon, current: location.pathname==='/valPage' ? true:false },
      { name: 'Pruebas', href: '/pruebaPage', icon: RssIcon, current: location.pathname==='/pruebaPage' ? true:false },
      { name: 'TAB - CAL', href: '/reportPage', icon: WalletIcon, current: location.pathname==='/reportPage' ? true:false },
      { name: 'Reporte Institución', href: '/reportPage1', icon: ChartBarIcon, current: location.pathname==='/reportPage1' ? true:false },
      { name: 'Reporte Comparativo', href: '/reportPage2', icon: ChartPieIcon, current: location.pathname==='/reportPage2' ? true:false },
      { name: 'Reporte Nodo', href: '/reportNodo', icon: ShareIcon, current: location.pathname==='/reportNodo' ? true:false },
      { name: 'Instituciones', href: '/valInsti', icon: AcademicCapIcon, current: location.pathname==='/valInsti' ? true:false },
      { name: 'Digitar', href: '/valForm', icon: PencilIcon, current: location.pathname==='/valForm' ? true:false },
      { name: 'Corregir', href: '/valCorr', icon: ArrowPathIcon, current: location.pathname==='/valCorr' ? true:false },
      { name: 'Eliminar', href: '/valDelete', icon: TrashIcon, current: location.pathname==='/valDelete' ? true:false },
      { name: 'Contraseña', href: '/valPassword', icon: WindowIcon, current: location.pathname==='/valPassword' ? true:false },
      { name: 'Municipio', href: '/valCiudad', icon: BuildingLibraryIcon, current: location.pathname==='/valCiudad' ? true:false },
      { name: 'Proyecto', href: '/valProyecto', icon: FolderIcon, current: location.pathname==='/valProyecto' ? true:false },

  ]

  return(
      <div>
          {navigation.map((item) => (
                <NavLink
                  key={item.name}
                  to={item.href}
                  className={classNames(
                    item.current ? 'bg-gray-100 text-gray-900' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900',
                    'group flex items-center px-2 py-2 text-sm font-medium rounded-md'
                  )}
                >
                  <item.icon
                    className={classNames(
                      item.current ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500',
                      'mr-3 flex-shrink-0 h-6 w-6'
                    )}
                    aria-hidden="true"
                  />
                  {item.name}
                </NavLink>
          ))}
      </div>
  )
}
export default Sidebar3
